import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/easel.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { EaselEffects } from './state/easel.effects';

import { EaselShellComponent } from './containers/easel-shell/easel-shell.component';
import { EaselListComponent } from './components/easel-list/easel-list.component';
import { EaselEditShellComponent } from './containers/easel-edit-shell/easel-edit-shell.component';
import { EaselEditComponent } from './components/easel-edit/easel-edit.component';



@NgModule({
  declarations: [
    EaselShellComponent,
    EaselEditShellComponent,
    EaselListComponent,
    EaselEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('easels', reducer),
    EffectsModule.forFeature([EaselEffects])
  ],
  exports: [
    EaselListComponent,
    EaselEditComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class EaselModule {
  constructor(
  ) {}
}
